// extracted by mini-css-extract-plugin
export default {"button":"styles_button__ETurx","back":"styles_back__5q4A0","ok":"styles_ok__P6cWd"};